import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { useTable, usePagination, useSortBy } from "react-table";
import { useHistory } from "react-router-dom";

const Styles = styled.div`
  padding: 1rem;
  margin-bottom: 50px;
  width: 100%;
  overflow-x: auto;
  table {
    width: 100%;
    height: 50px;

    thead {
      background-color: #23297a;
    }
    td {
      border: 1px rgb(201, 204, 216);
      border-style: solid none solid none;
      padding: 10px;
    }
    tr {
      height: 60px;
      width: 1086px;
      left: 309px;
      top: 350px;
      border-radius: 5px !important;
    }
    // tr:hover {
    //   background: #f5f5ff;
    // }
    th {
      color: #ffff;
    }
    th:first-child {
      border-top-left-radius: 10px;
    }

    th:last-child {
      border-top-right-radius: 10px;
    }
    span {
      margin: 5px;
    }
    th,
    td {
      border-bottom: 1px solid #f5f5ff;
      border-right: 0px solid black;
      padding: 10px;
      white-space: nowrap;
      text-align: start;

      :last-child {
        border-right: 0;
        text-align: start;
      }
    }
  }
  .pagination {
    height: 50px;
    padding: 0.2rem 0;
    position: absolute;
    align-items: baseline;
    right: 14px;
    justify-content: end;
    button,
    select {
      margin: 2px 20px 0px 0px !important;
    }
    button {
      border: 1px solid #999999;
      background-color: #dcdcdc; // #ffffff;
      color: #ffff;
      margin: 16px 10px;
    }

    button:hover {
      border: 1px solid #999999; //#0099cc;
    }

    button:disabled,
    button[disabled] {
      border: 1px solid #999999;
      background-color: #ffffff; //#cccccc;
    }
  }

  @media (max-width: 1536px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 14px !important;
      // bottom: 15px !important;
    }
  }

  @media (max-width: 1280px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 15px;
    }
  }
  @media (max-width: 1098px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: 14px !important ;
    }
  }

  @media (max-width: 768px) {
    .pagination {
      height: 50px;
      padding: 0;
      right: -1px !important;
    }
  }
  .double-screen-pagination {
    height: 50px;
    padding: 0.2rem 0;
    position: absolute;
    align-items: baseline;
    right: 15px;
    justify-content: end;
    button,
    select {
      margin: 2px 0px 0px 0px;
    }
    button {
      border: 1px solid #999999;
      background-color: #dcdcdc; // #ffffff;
      color: #666666;
      margin: 16px 10px;
    }

    button:hover {
      border: 1px solid #999999; //#0099cc;
    }

    button:disabled,
    button[disabled] {
      border: 1px solid #999999;
      background-color: #ffffff; //#cccccc;
    }
  }

  @media (max-width: 1920px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 18px !important;
    }
  }

  @media (max-width: 1536px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 18px !important;
    }
  }

  @media (max-width: 1280px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 18px !important;
    }
  }
  @media (max-width: 1098px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 18px !important;
    }
  }

  @media (max-width: 768px) {
    .double-screen-pagination {
      height: 50px;
      padding: 0;
      right: 18px !important;
    }
  }
`;

var typeMotion = "";
var totalPageCount = 0;
var tempTigger;

function NewTableFilter({
  columns,
  data,
  pagination,
  defaultFilterMethod,
  paginationDoubleScreen,
  swapStationCount,
  pageLimitHandle,
  setCurrentPageLimit1,
  filterAction,
  // scroll,
  setPSize,
  paginationCountHanlde,
  tigger,
  tempHeaderFilter,
  filter,
  searchString,
}) {

 
  // Use the state and functions returned from useTable to build your UI
  const moveScroll = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // scroll();
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    gotoPage,
    pageOptions,
    nextPage,
    pageCount,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      // <<<<<<< HEAD
      initialState: {
        pageIndex: tigger === "amhitted" ? 0 : 0,
        pageSize: 10,
        tempTigger: tigger,
      },
      // disableSortRemove: false
      // =======
      // initialState: { pageIndex: 0 },
      // >>>>>>> 9f5c23a3b2a8d9a67b941ab1c2991b1e4b255a09
      defaultFilterMethod,
    },
    useSortBy,
    usePagination
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageLimit, setCurrentPageLimit] = useState(10);
  const [rowDivided, setrowDivided] = useState(0);
  const [tableSrollTrigger, setTableScrollTigger] = useState(false);
  const [prevtableSrollTrigger, setPrevtableSrollTrigger] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(0);

  const haneldCall = (type) => {
    tempTigger = "init";
    typeMotion = type;

    // type === "back" ? previousPage() : nextPage()
    if (type === "back") {
      if (currentPage > 0) {
        let currentPageNumbernew = currentPage - 1;
        setCurrentPageNumber(currentPageNumbernew);
        setCurrentPage(currentPage - 1);
        pageLimitHandle(
          currentPageNumbernew,
          currentPageLimit,
          tigger,
          searchString
        );
        paginationCountHanlde &&
          paginationCountHanlde(
            currentPageNumbernew,
            currentPageLimit,
            tigger,
            tempHeaderFilter
          );
      } else {
        return;
      }
    } else {
      if (currentPage < rowDivided) {
        let currentPageNumbernew = currentPage + 1;
        setCurrentPageNumber(currentPageNumbernew);
        setCurrentPage(currentPage + 1);
        pageLimitHandle(
          currentPageNumbernew,
          currentPageLimit,
          tigger,
          searchString
        );
        paginationCountHanlde &&
          paginationCountHanlde(
            currentPageNumbernew,
            currentPageLimit,
            tigger,
            tempHeaderFilter
          );
      } else {
        return;
      }
    }

    moveScroll();
  };

  const selectPageLimitHandle = (e) => {
    setPageSize(e);
    setPSize && setPSize(e);
    setCurrentPageLimit(e);
    setCurrentPageLimit1(e);
    setCurrentPage(0);
    setCurrentPageNumber(0);
    pageLimitHandle(0, e, tigger, searchString);
    paginationCountHanlde && paginationCountHanlde(0, e, tigger);
  };

  useEffect(() => {
    if (!filterAction) {
      setCurrentPageNumber(tigger == "amhitted" ? 0 : currentPageNumber);
      return;
    }

    if (filterAction[0] == 1) {
      if (tempTigger == "amhitted") {
        setPageSize(10);
        setCurrentPageLimit(10);
        setCurrentPageLimit1(10);
        setCurrentPageNumber(0);
        setCurrentPage(0);
      } else {
        setPageSize(10);
        setCurrentPageLimit(10);
        setCurrentPageLimit1(10);
        // currentPageNumber = tempTigger == "amhitted"  ? 0  : currentPageNumber;

        setCurrentPage(tigger == "init" ? 0 : currentPageNumber); // pageLimitHandle && pageLimitHandle(currentPageNumber, currentPageLimit, tigger, searchString);
      }
      return;
    }
    if (filterAction[0] == 2) {
      setCurrentPage(0);
      setPageSize(10);
      setCurrentPageLimit(10);
      setCurrentPageLimit1(10);
      setCurrentPageNumber(0);
      return;
    }
  }, [filterAction]);

  useEffect(() => {
    console.log(tigger, "=--==", tempTigger, "runigngg EVERY");
  }, [data]);

  useEffect(() => {
    var tempCount = 0;
    if (swapStationCount) {
      // console.log(swapStationCount,"swapStationCount_________")
      // setrowDivided(0)
      if (pageSize == 10) {
        totalPageCount = swapStationCount % 10;
        tempCount = Math.floor(swapStationCount / 10);
        if (totalPageCount > 0) {
          // rowDivided = rowDivided + 1;
          setrowDivided(tempCount + 1);
          // currentPage = currentPage +1;
        } else {
          setrowDivided(tempCount);
        }
      } else if (pageSize == 20) {
        totalPageCount = swapStationCount % 20;
        tempCount = Math.floor(swapStationCount / 20);

        if (totalPageCount > 0) {
          // rowDivided = rowDivided + 1;
          setrowDivided(tempCount + 1);
          // currentPage = currentPage +1;
        } else {
          setrowDivided(tempCount);
        }
      } else if (pageSize == 30) {
        totalPageCount = swapStationCount % 30;
        tempCount = Math.floor(swapStationCount / 30);

        if (totalPageCount > 0) {
          // rowDivided = rowDivided + 1;
          setrowDivided(tempCount + 1);
          // currentPage = currentPage +1;
        } else {
          setrowDivided(tempCount);
        }
      } else if (pageSize == 40) {
        totalPageCount = swapStationCount % 40;
        tempCount = Math.floor(swapStationCount / 40);

        if (totalPageCount > 0) {
          // rowDivided = rowDivided + 1;
          setrowDivided(tempCount + 1);
          // currentPage = currentPage +1;
        } else {
          setrowDivided(tempCount);
        }
      } else if (pageSize == 50) {
        totalPageCount = swapStationCount % 50;
        tempCount = Math.floor(swapStationCount / 50);

        if (totalPageCount > 0) {
          // rowDivided = rowDivided + 1;
          setrowDivided(tempCount + 1);
          // currentPage = currentPage +1;
        } else {
          console.log(tempCount, "am laast else");
          setrowDivided(tempCount);
        }
      }
    }
    setCurrentPage(currentPageNumber);
    // console.log(currentPage,"3944444444444++++")
    // console.log(currentPageNumber,"3955555555555===")
    // paginationAssetsHandle();
  }, [swapStationCount, data]);

  const paginationAssetsHandle = () => {
    // setCurrentPage(currentPageNumber)
    // pageLimitHandle && pageLimitHandle(currentPageNumber, currentPageLimit, tigger, searchString);
    console.log(tigger, "CHECKINGGG");
    // tigger == "amhitted" ? setCurrentPage(0)   : setCurrentPage(currentPageNumber)
    // if(tigger !== "view"){
    //   console.log(tigger,"am ifffffffffffffffff")
    //   // setCurrentPage(currentPageNumber)
    // } else {
    //   console.log(tigger,"am elcsssysysyy")
    //   // paginationCountHanlde && paginationCountHanlde(currentPageNumber, currentPageLimit, tigger)

    //   // paginationCountHanlde && paginationCountHanlde(currentPageNumber, e, tigger)
    // }
  };
  const firstPageRows = rows.slice(0, 10);
  // Render the UI for your table
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // prevtableSrollTrigger || currentPage > 0 && !canNextPage
    // ?
    // ( console.log(currentPage,"am runing"),
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" }))
    // : null
  }, [prevtableSrollTrigger, currentPage, canNextPage]);
  return (
    <>
      <table {...getTableProps()} id="data_table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, idx) =>
                !column.hideHeader ? (
                  <th
                  id={String(column.render("Header")).trim().replace(/ /g, "_")}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " ↓"
                          : " ↑"
                        : ""}
                    </span>
                  </th>
                ) : (
                  <></>
                )
              )}
            </tr>
          ))}
        </thead>
        <tbody id="data_table_body" {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            
            return (
              <tr id={"data_table_row_" + i} {...row.getRowProps()}>
              
                {row.cells.map((cell, j) => {
                  return (
                    <td
                      id={i + "_col_" + j}
                      {...cell.getCellProps({
                        style: {
                          minWidth: cell.column.minWidth,
                          width: cell.column.width,
                          fontSize:
                            cell.row.values.serialNumber === "Total Tax Amount"
                              ? "18px"
                              : "",
                          color:
                            cell.row.values.serialNumber === "Total Tax Amount"
                              ? "#262626"
                              : "",
                        },
                      })}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        {/* tableSrollTrigger */}
        {/* {   ( prevtableSrollTrigger || currentPage > 0 && !canNextPage  )
          ?
          ( console.log(currentPage,"am runing"),
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" }))
          : null} */}
      </table>
      {/*   
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      {data.length > 0 && pagination ? (
        <div
          id="pagination"
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "space-between",
            width: "94%",
          }}
          className={
            paginationDoubleScreen ? "double-screen-pagination" : "pagination"
          }
        >
          <div
            id="pagination_showing"
            style={{ fontWeight: "500", minHeight: "100px" }}
          >
            {/* Showing {page.length} of {swapStationCount} Records */}
            Showing {currentPage * pageSize + 1}-
            {Math.min((currentPage + 1) * pageSize, swapStationCount)} of{" "}
            {swapStationCount} Records
          </div>
          {/* <button onClick={() => previousPage()} disabled={!canPreviousPage}> */}
          <div>
            <button
              id="page_back_btn"
              //  disabled={currentPage === rowDivided ? !canNextPage : '' }
              disabled={currentPage <= 0}
              onClick={() => {
                setTableScrollTigger(() => true);
                setPrevtableSrollTrigger(() => true);
                haneldCall("back");
              }}
            >
              {"<"}
            </button>
            {""}
            <span style={{ margin: "21px 0px" }}>
              Page <strong>{currentPageNumber + 1}</strong>{" "}
              {/* <strong>{ rowDivided   }</strong>{" "} */}
              of {/* { pageOptions.length===0?1:pageOptions.length}{" "} */}
              {pageOptions.length === 0 ? 0 : rowDivided}{" "}
            </span>
            <button
              id="page_front_btn"
              type="button"
              disabled={currentPage >= rowDivided - 1}
              // disabled={ canNextPage }
              onClick={() => {
                setTableScrollTigger(() => false);
                setPrevtableSrollTrigger(() => false);
                haneldCall("front");
              }}
            >
              {">"}
            </button>
            {/* <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button> */}{" "}
            <select
              value={currentPageLimit}
              onChange={(e) => {
                selectPageLimitHandle(parseInt(e.target.value));
                moveScroll();
              }}
            >
              {[10, 20, 30, 40, 50].map((pageSize) => {
                return <option value={pageSize}>Show {pageSize}</option>;
              })}
            </select>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
function filterCaseInsensitive(filter, row) {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
    : true;
}
function ZoneTable(props) {
  const history = useHistory();
  const [checkBox,setCheckbox]=useState(false)
  return (
    <Styles>
      <NewTableFilter
        columns={props.columns}
        data={props.data}
        // scroll={props.scroll}
        pagination={props?.noPaging ? "" : !props.pagination}
        defaultFilterMethod={(filter, row) =>
          filterCaseInsensitive(filter, row)
        }
        paginationDoubleScreen={props.paginationDoubleScreen}
        swapStationCount={props.swapStationCount}
        invoiceStyle={true}
        setCurrentPageLimit1={props.setCurrentPageLimit}
        filterAction={props.filterAction}
        searchString={props.searchString}
        filter={props.filter}
        setPSize={props.setPSize} // tigger={history.location.state.compomentRenderType}
        offset={props.offset}
        tigger={
          typeof props.tigger === "undefined"
            ? history?.location?.state?.compomentRenderType
            : props?.tigger
        }
        pageNumber={props.pageNumber}
        paginationCountHanlde={props?.paginationCountHanlde}
        pageLimitHandle={props.pageLimitHandle}
        tempHeaderFilter={props.tempHeaderFilter}
        enableCheckBox={props.enableCheckBox}
        onCheckboxChange={()=>{setCheckbox(true)}}
      />
    </Styles>
  );
}

export default ZoneTable;
